import React, { useState, useEffect } from "react";
import "./HeroScreen.css";
import { getCloudinaryUrl } from "../utils/cloudinary";

function HeroScreen({ image, title, text, height, opacity, title_size = "4.3rem" }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [currentSrc, setCurrentSrc] = useState('');

    // Generate both thumbnail (blur) and full quality URLs
    const thumbnailUrl = getCloudinaryUrl(image, { 
        width: 50,      // Tiny thumbnail (~1-2KB)
        quality: 30,
        format: 'auto',
        crop: 'fill'
    });

    const fullUrl = getCloudinaryUrl(image, { 
        width: 1920, 
        quality: 90, 
        format: 'auto',
        crop: 'fill'
    });

    useEffect(() => {
        // Start with thumbnail immediately
        setCurrentSrc(thumbnailUrl);
        setIsLoaded(false);

        // Preload full image in background
        const img = new Image();
        img.src = fullUrl;
        
        img.onload = () => {
            setCurrentSrc(fullUrl);
            setIsLoaded(true);
        };

        // Cleanup
        return () => {
            img.onload = null;
        };
    }, [image, thumbnailUrl, fullUrl]);

    return (
        <section 
            className="hero"
            style={{ height: height }}
        >
            {/* Background Image with Progressive Loading */}
            <img 
                src={currentSrc}
                alt={title} 
                className="hero-image"
                fetchPriority="high"
                style={{ 
                    opacity: opacity,
                    filter: isLoaded ? 'none' : 'blur(10px)', // Blur until loaded
                    transition: 'filter 0.3s ease-out'
                }}
            />

            {/* Content container */}
            <div className="quote">
                <div className="quote-title" style={{ fontSize: title_size }}>
                    {title}
                </div>
                {text && (
                    <div className="quote-text">
                        {text}
                    </div>
                )}
            </div>
        </section>
    );
}

export default HeroScreen;